import { SECONDARY_BUDGET_AXIS_ELEMENT_SOFTWARE_ID } from 'routes/BudgetModule/config/constants';
import { getOperationUrl } from 'routes/BudgetModule/components/Operation360/helpers/url';
import { BudgetExpenseOrIncome } from 'business/constants';
import {
    DraftOperationT,
    SecondaryBudgetAxisElementT,
} from 'routes/BudgetModule/config/types';

export const getOperationUrlBySoftwareId = (
    operationSoftwareId:
        | SecondaryBudgetAxisElementT['secondaryBudgetAxisElement.softwareId']
        | DraftOperationT['softwareId'],
    location: LocationT,
): { pathname: string; state: { parentLocation: LocationT } } => ({
    pathname: getOperationUrl(
        encodeURIComponent(operationSoftwareId),
        BudgetExpenseOrIncome.EXPENSE,
    ),

    state: { parentLocation: location },
});

export const getUrl = (
    operation: Pick<
        SecondaryBudgetAxisElementT,
        typeof SECONDARY_BUDGET_AXIS_ELEMENT_SOFTWARE_ID
    >,
    location: LocationT,
): { pathname: string; state: { parentLocation: LocationT } } =>
    getOperationUrlBySoftwareId(
        operation[SECONDARY_BUDGET_AXIS_ELEMENT_SOFTWARE_ID],
        location,
    );
